export default "__VITE_ASSET__DDb3lSRf__"